export const SeriesEmblem = ({ name = "", emblem, size = 56, className = "" }) => {
  const variant = emblem !== undefined && emblem !== "" && emblem !== null
    ? Number(emblem)
    : name.split("").reduce((a, c) => a + c.charCodeAt(0), 0) % 3;
  const h = Math.round(size * 0.66);
  return (
    <svg width={size} height={h} viewBox="0 0 60 40" fill="none"
      className={className} data-testid={`series-emblem-${variant}`} aria-hidden="true">
      {variant === 0 && (
        <>
          <path d="M8 38C8 18 18 8 30 4C42 8 52 18 52 38" stroke="#3a3d4d" strokeWidth="1" />
          <path d="M16 38C16 24 22 15 30 12C38 15 44 24 44 38" stroke="#581313" strokeWidth="1" />
          <circle cx="30" cy="33" r="2" fill="#581313" />
        </>
      )}
      {variant === 1 && (
        <>
          <path d="M12 38C18 27 21 20 23 5M23 5C25 20 28 27 34 38M17 27l6 5M29 27l-6 5" stroke="#581313" strokeWidth="1" />
          <path d="M42 38C40 30 40 22 44 12M44 12C46 20 48 26 52 32" stroke="#3a3d4d" strokeWidth="1" />
          <path d="M6 38H56" stroke="#3a3d4d" strokeWidth="0.75" />
        </>
      )}
      {variant === 2 && (
        <>
          <circle cx="23" cy="20" r="13" stroke="#581313" strokeWidth="1" />
          <circle cx="37" cy="20" r="13" stroke="#581313" strokeWidth="1" />
          <path d="M30 10V30" stroke="#3a3d4d" strokeWidth="0.75" />
        </>
      )}
    </svg>
  );
};
